import React from 'react';
import {FilterPopup} from '@new-components/molecules/FilterPopup';
import MuiBox from '@new-components/atoms/MuiBox';
import MuiDivider from '@new-components/atoms/MuiDivider';
import MuiMenuList from '@new-components/atoms/MuiMenuList';
import MuiMenuItem from '@new-components/atoms/MuiMenuItem';

type Option = {
  label: string;
  value: string;
};

type AvailabilityOptionProps = {
  options: Option[];
  value: string;
  handleChange: (arg: string) => void;
};
const AvailabilityOption = (props: AvailabilityOptionProps) => {
  const [popupOpen, setPopupOpen] = React.useState(false);

  const handleOnclick = (value: string) => {
    props.handleChange(value);
    setPopupOpen(false);
  };

  return (
    <FilterPopup
      label='Availability'
      value={props.value}
      open={popupOpen}
      onToggle={() => setPopupOpen(!popupOpen)}
      sx={{
        popup: {
          '& .MuiPopover-paper': {
            width: '228px',
            borderRadius: '16px',
            padding: '0px',
          },
        },
        trigger: {},
      }}>
      <MuiMenuList sx={{padding: '0px'}}>
        {[{label: 'Any', value: 'Any'}, ...props.options].map((option, index) => (
          <MuiBox>
            <MuiMenuItem
              selected={props.value === option.value}
              onClick={() => handleOnclick(option.value)}
              sx={{
                'fontSize': '16px',
                'fontWeight': 400,
                'color': '#000000',
                'paddingY': '12px',
                '&.Mui-selected': {backgroundColor: '#EDECE8'},
              }}>
              {option.label}
            </MuiMenuItem>
            {index < props.options.length - 1 && (
              <MuiDivider sx={{'&.MuiDivider-root': {margin: 0}}} />
            )}
          </MuiBox>
        ))}
      </MuiMenuList>
    </FilterPopup>
  );
};

export default AvailabilityOption;
